import { PayloadAction, createSlice } from "@reduxjs/toolkit";

interface GlobalState {
  globalPopupElement: React.JSX.Element | null;
  socialLinksWidget: SocialLinksWidget | null;
  pageSettings: PageSettingsWidget | null;
  /** per-page settings coming from builder pages (bg color etc.) */
  builderPageSettings: any;
  searchProducts: ProductItemV2[];
  searchLoading: boolean;
  appliedPoint: number;
  isUserReviewed: { [key: number]: boolean };
  searchQuery: string;
}

const initialState: GlobalState = {
  globalPopupElement: null,
  socialLinksWidget: null,
  pageSettings: null,
  builderPageSettings: null,
  searchProducts: [],
  searchLoading: false,
  appliedPoint: 0,
  isUserReviewed: {},
  searchQuery: "",
};

const globalSlice = createSlice({
  name: "global",
  initialState,
  reducers: {
    setGlobalPopupElement: (
      state,
      action: PayloadAction<React.JSX.Element | null>
    ) => {
      state.globalPopupElement = action.payload;
    },

    setSocialLinksWidget: (
      state,
      action: PayloadAction<SocialLinksWidget | null>
    ) => {
      state.socialLinksWidget = action.payload;
    },
    setPageSettings: (
      state,
      action: PayloadAction<PageSettingsWidget | null>
    ) => {
      state.pageSettings = action.payload;
    },
    setSearchProducts: (state, action: PayloadAction<ProductItemV2[]>) => {
      state.searchProducts = action.payload;
      state.searchLoading = false;
    },
    setSearchLoading: (state, action: PayloadAction<boolean>) => {
      state.searchLoading = action.payload;
    },
    setAppliedPoint: (state, action: PayloadAction<number>) => {
      state.appliedPoint = action.payload;
    },
    setIsUserReviewed: (
      state,
      action: PayloadAction<{ [key: number]: boolean }>
    ) => {
      state.isUserReviewed = {
        ...state.isUserReviewed,
        ...action.payload,
      };
    },

    setSearchQuery: (state, action: PayloadAction<string>) => {
      state.searchQuery = action.payload;
    },

    setBuilderPageSettings: (
      state,
      action: PayloadAction<any>
    ) => {
      state.builderPageSettings = action.payload;
    },
  },
});

export const {
  setGlobalPopupElement,
  setSocialLinksWidget,
  setPageSettings,
  setSearchProducts,
  setSearchLoading,
  setIsUserReviewed,
  setAppliedPoint,
  setSearchQuery,
  setBuilderPageSettings,
} = globalSlice.actions;

export default globalSlice.reducer;
